/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const campaignUsageRequestDataTypeSchema = z.enum(['request_more_campaigns', 'request_upgrade'])

export type CampaignUsageRequestDataTypeSchema = z.infer<typeof campaignUsageRequestDataTypeSchema>
